import React from 'react';
import { Section, CopyWrapper } from './DoubleCopy.style';

var DoubleCopy = function DoubleCopy(_ref) {
  var leftCopy = _ref.leftCopy,
      rightCopy = _ref.rightCopy;
  return React.createElement(Section, null, React.createElement(CopyWrapper, null, leftCopy), React.createElement(CopyWrapper, null, rightCopy));
};

export default DoubleCopy;